import { z } from 'zod'

import {
  MembershipReferralStatus,
  MembershipReferralType,
} from '../constants/membership'
import { dbEntitySchema } from './system'

export const membershipReferralSchema = dbEntitySchema.extend({
  user: z.string(),
  status: z.nativeEnum(MembershipReferralStatus),
  referredUser: z.string(),
  referredUserName: z.string().optional().nullable(),
  referredMembership: z.string(),
  referredMembershipPlanName: z.string().optional().nullable(),
})

export const membershipReferralCreateDataSchema = z.object({
  user: z.string(),
  status: z.nativeEnum(MembershipReferralStatus),
  referredUser: z.string(),
  referredUserName: z.string().optional().nullable(),
  referredMembership: z.string(),
  referredMembershipPlanName: z.string().optional().nullable(),
})

export const membershipReferralCreateConfirmedUserReferralArgsSchema = z.object(
  {
    userId: z.string(),
    status: z.nativeEnum(MembershipReferralStatus),
    referredUserId: z.string(),
    referredUserName: z.string().optional().nullable(),
    referredMembershipId: z.string(),
    referredMembershipPlanName: z.string().optional().nullable(),
  }
)

export const membershipReferralCreatedEventPayloadSchema = z.object({
  id: z.string(),
})

export const membershipReferralMemberSchema = z.object({
  id: z.string().optional(),
  type: z.nativeEnum(MembershipReferralType).optional(),
})
